import React from "react";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { MetaTag } from "next-seo/lib/types";
import { useLocale } from "next-intl";
interface Props {
  seoTitle?: string;
  seoDescription?: string;
  seoKeywords?: string;
  imageUrl?: string;
  url?: string;
  noIndex?: boolean;
  contentBuilderCSS?: {
    rel: string;
    href: string;
  }[];
  metaTags?: MetaTag[];
}
function SeoHeader({
  seoTitle = "",
  seoDescription = "",
  imageUrl = "",
  url = "",
  noIndex = false,
  contentBuilderCSS = [],
  metaTags = []
}: Props) {
  const router = useRouter();
  const locale = useLocale();
  const title = seoTitle;
  const desc = seoDescription;
  const ogImgRelativePath = "/icon-512x512.png";
  const siteURL = "https://qrcodecreator.com";
  const ogImageURL = imageUrl ? imageUrl : `${siteURL}${ogImgRelativePath}`;
  const pathName = router.asPath;
  const pageURL = url ? url : `${siteURL}${pathName}`;
  const twitterHandle = "@qrcodecreator";
  const siteName = "qrcodecreator.com";
  const urlWithoutQuery = pageURL.includes("?") ? pageURL.split("?")[0] : pageURL;
  return <>
      <NextSeo title={title} description={desc} canonical={urlWithoutQuery} noindex={noIndex} nofollow={noIndex} openGraph={{
      type: "website",
      locale: locale,
      url: urlWithoutQuery,
      title,
      description: desc,
      images: [{
        url: ogImageURL,
        width: 877,
        height: 523,
        alt: `qrcodecreator.com`
      }],
      site_name: siteName
    }} twitter={{
      handle: twitterHandle,
      site: twitterHandle,
      cardType: "summary_large_image"
    }} additionalMetaTags={[{
      name: "googlebot",
      content: noIndex ? "noindex,nofollow" : "index,follow"
    }, ...metaTags]} additionalLinkTags={[...contentBuilderCSS]} data-sentry-element="NextSeo" data-sentry-source-file="SeoHeader.tsx" />
    </>;
}
export default SeoHeader;